import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Layout, PageHeader, Space, Spin } from 'antd';
import DescriptionsChampion from './DescriptionsChampion';
import DescriptionsChallenger from './DescriptionsChallenger';
import { ApproveOrRejectComponent } from '../components/TableComponents';
import style from './index.scss';
import { dateToDDMMYYYYTTMMUniversal } from '../../common/utils/formatter';
import { TM_FRAUD_SOURCE_IDS } from '../../../util/GlobalConstant';
import FlagRed from '../../../assets/flag_Red.svg';
import FlagOrange from '../../../assets/flag_Orange.svg';
import TypologyRules from '../components/typologies/TypologyRules';
import TypologyCarousel from '../components/typologies/carousel/TypologyCarousel';

const TicketDetails = ({
  trmDashboard = {},
  apiActions,
  match,
  history,
  location,
  alertLevels
}) => {
  const {
    fetchCurrentChallenger,
    fetchCurrentChampion,
    approveRejectTickets,
    fetchAMLSAlertLevel
  } = apiActions;

  const { currentChallenger, currentChampion } = trmDashboard || {};
  const {
    data: challengerData,
    error,
    isLoading: isChallengerLoading
  } = currentChallenger || {};
  const {
    data: currentChampData,
    error: currentChampError,
    isLoading: isCurrentChampLoading
  } = currentChampion || {};

  const queryParams = new URLSearchParams(location.search);
  const sourceId = Number(queryParams?.get('sourceId'));
  const isScheduled = queryParams?.get('scheduled') === 'true';
  const isPrevention = sourceId === Number(TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID);

  useEffect(() => {
    fetchCurrentChallenger({
      challengerID: match.params.id
    });

    // Fetch alert level configs to display the configured alert level label and color.
    if (!alertLevels?.length) {
      fetchAMLSAlertLevel();
    }
  }, [match.params.id]);

  useEffect(() => {
    fetchCurrentChampion({
      sourceId,
      scheduled: queryParams?.get('scheduled') ? isScheduled : null
    });
  }, [sourceId]);

  let challengersObject = {};
  let currentChampionObject = {};
  let btnText = '';

  const getHeaderTitleFromRequestType = (requestType = 'Challenger') => {
    switch (requestType) {
      case 'CreateChallenger':
        return 'Approve New Challenger';
      case 'PromoteChampion':
        return 'Promote to Champion';
      default:
        return 'Approve New Challenger';
    }
  };

  if (!isChallengerLoading && !error && challengerData) {
    challengersObject = challengerData;
    const { requestType } = challengersObject;
    btnText = getHeaderTitleFromRequestType(requestType);
  }
  if (!isCurrentChampLoading && !currentChampError && currentChampData) {
    currentChampionObject = currentChampData;
  }

  const onAction = (payload) => {
    approveRejectTickets(payload);
    setTimeout(() => {
      history.push(`/app/trm/tickets`);
    }, 1000);
  };

  const isChampionPresent = !!(
    !!currentChampionObject && Object.keys(currentChampionObject).length
  );

  return (
    <Layout className="layout">
      <PageHeader
        ghost={false}
        onBack={() => history.push(`/app/trm/tickets/?sourceId=${sourceId}`)}
        title={
          <span>
            Ticket Details &nbsp;| &nbsp;
            {sourceId === Number(TM_FRAUD_SOURCE_IDS.TM) && (
              <span>
                <img
                  alt=""
                  style={{ height: '26px', paddingBottom: '2px' }}
                  src={FlagOrange}
                />
                &nbsp; AML-TM Detection
              </span>
            )}
            {sourceId === Number(TM_FRAUD_SOURCE_IDS.FRAUD) && (
              <span>
                <img
                  alt=""
                  style={{ height: '26px', paddingBottom: '2px' }}
                  src={FlagRed}
                />
                &nbsp; Fraud Detection
              </span>
            )}
            {isPrevention && (
              <span>
                <img
                  alt=""
                  style={{ height: '26px', paddingBottom: '2px' }}
                  src={FlagRed}
                />
                &nbsp; Fraud Prevention
                {isScheduled && ' - Scheduled'}
              </span>
            )}
          </span>
        }
        footer={`ID: ${match.params.id}`}
      />

      <Spin spinning={isChallengerLoading || isCurrentChampLoading}>
        <div
          style={{
            padding: 20,
            backgroundColor: '#BEC3CB',
            display: 'flex',
            flexDirection: 'column'
          }}>
          {isChampionPresent && (
            <div style={{ backgroundColor: 'white', padding: 20 }}>
              <div
                style={{
                  backgroundColor: 'white',
                  borderBottomLeftRadius: 4,
                  borderBottomRightRadius: 4
                }}>
                <Space size={5} direction="vertical">
                  <div className={style.title}>
                    Current Champion (In Production)
                  </div>

                  <DescriptionsChampion
                    {...currentChampionObject}
                    isFraudPrevention={
                      challengersObject?.sourceId ===
                      parseInt(TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID)
                    }
                    alertLevels={alertLevels}
                  />
                  {isPrevention ? (
                    <TypologyRules
                      typologies={currentChampionObject.typologies}
                    />
                  ) : (
                    // <SetsComponent
                    //   trmDashboard={trmDashboard}
                    //   dataType="currentChampion"
                    // />
                    <TypologyCarousel
                      headerLabel={'Current Champion (In Production)'}
                      typologySets={
                        currentChampionObject.categorizedTypologies || []
                      }
                    />
                  )}
                </Space>
              </div>
            </div>
          )}

          <div style={{ backgroundColor: 'white', padding: 20, marginTop: 20 }}>
            <div
              style={{
                backgroundColor: 'white',
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4
              }}>
              <Space size={5} direction="vertical">
                <div className={style.title}>
                  Challenger ID : &nbsp; {challengersObject?.challengerId}{' '}
                  <br />
                </div>
                <span className={style.titleDetail}>
                  Newly created by: {challengersObject?.createdBy}{' '}
                  <div style={{ margin: '0 8px', display: 'inline' }} />
                  Create date:{' '}
                  {dateToDDMMYYYYTTMMUniversal(
                    challengersObject?.createdAt,
                    '14'
                  )}
                </span>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    marginBottom: 12
                  }}>
                  <ApproveOrRejectComponent
                    inDetail
                    showButtons
                    btnText={btnText}
                    ticket={{
                      id: match.params.id,
                      state: challengersObject.status
                    }}
                    onAction={onAction}
                  />
                </div>
                <DescriptionsChallenger
                  {...challengersObject}
                  isFraudPrevention={
                    sourceId === parseInt(TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID)
                  }
                  alertLevels={alertLevels}
                />
                {isPrevention ? (
                  <TypologyRules typologies={challengersObject.typologies} />
                ) : (
                  <TypologyCarousel
                    headerLabel={`Challenger ID : ${challengersObject.challengerId}`}
                    typologySets={challengersObject.categorizedTypologies || []}
                  />
                )}
              </Space>
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  );
};

TicketDetails.propTypes = {
  trmDashboard: PropTypes.object,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  apiActions: PropTypes.object.isRequired,
  alertLevels: PropTypes.array
};

export default TicketDetails;
